import React from 'react'

export default function WeddingTradition() {
  return (
    <>
    <section className="weddpage-trad">
        <div className="container">
            <div className="row">

                <div className="col-lg-6 col-md-6">
                    <div className="weddtrad-1">
                        <span className='gradient-color'> 
                            <img src="/image/sparkle.webp" alt="Wedding" loading="lazy"/> TIMELESS INDIAN WEDDINGS <img src="/image/sparkle.webp" alt="Wedding" loading="lazy"/>
                        </span>
                        <h2 className='heading'>Where Tradition Meets Modern Romance</h2>
                        <img src="/image/Wedding-trend-1.webp" className="img-responsive" alt="Wedding" loading="lazy"/>
                    </div>
                </div>

                <div className="col-lg-6 col-md-6">
                    <div className="weddtrad-2">
                        <img src="/image/Wedding-trend-2.webp" className="img-responsive" alt="Wedding" loading="lazy"/>
                        <p>Handcrafted bridal designs at Sonam Label blend heritage and contemporary style, elevating every wedding moment with elegance, sophistication, and timeless beauty. From the first look to the last dance, our couture bridalwear reflects the spirit of your love story.</p>
                    </div>
                </div>

            </div>
        </div>
    </section>
    </>
  )
}
